module.exports = __webpack_public_path__ + "img/Fly.a00cbc47.png";